import styled from '@emotion/styled';
import React from 'react';
import Text02Img from 'ui/images/article/text_02.svg';

const DescriptionText = styled.p`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 0.96rem;
    line-height: 160%;
    letter-spacing: 0.8px;
    color: #1e4e66;
    margin: 0;
`;

const HighlightText = styled.span`
    font-weight: 600;
    color: #ee793f;
    background-color: #fffbc9;
`;

const ContentWrapper = styled.div`
    position: relative;
    width: 100%;
    margin-top: 40px;
    display: flex;
    justify-content: center;
`;

export const MaForBeginnerDerail_1_3: React.FC = () => {
    return (
        <>
            <DescriptionText>
                M&Aは次のような流れで進みます。
                <br />
                ①仲介会社に相談し、会社の株価や事業価値を査定する
                <br />
                ②候補となる買い手企業を探し、秘密保持契約を結んだうえで情報開示を行う
                <br />
                ③条件面で合意が得られれば基本合意契約を結び、買い手がデューデリジェンス（財務・法務・事業の詳細調査）を実施する
                <br />
                ④その結果に基づき最終契約を締結し、クロージング（譲渡実行）を経てM&Aが成立
                <br />
                全体の期間は6か月から1年以上に及ぶこともあり、
                <HighlightText>粘り強い準備と適切な伴走者が欠かせません。</HighlightText>
            </DescriptionText>
            <ContentWrapper>
                <img src={Text02Img} alt="M&Aの流れ" style={{ width: '100%', height: 'auto' }} />
            </ContentWrapper>
        </>
    );
};
